import { Card, CardBody, Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import { LI, UL } from "../../../AbstractElements";
import { Link } from "react-router-dom";

function UserReport() {
  const { t } = useTranslation();
  return (
    <Col xl="4" md="6">
      <Card className="custom-list-group">
        <div className="alert alert-light-primary fade show p-1 mt-3 border-top-right-radius">
          <h4 className="light-primary p-1 d-flex justify-content-center">
            {t("UsersReport")}
          </h4>
        </div>
        <CardBody>
          <div className="chart-overflow" style={{ height: 400 }}>
            <UL className="list-content">
              <Link to={`${process.env.PUBLIC_URL}/reports/user-activity-report`}>
                <LI className="list-hover-primary">
                  <i className="icofont icofont-user text-primary"></i>
                  {t("UserActivity")}
                </LI>
              </Link>
              <Link to={`${process.env.PUBLIC_URL}/reports/last-login-report`}>
                <LI className="list-hover-primary">
                  <i className="icofont icofont-clock-time text-warning"></i>
                  {t("LastLoginReport")}
                </LI>
              </Link>
              <Link
                to={`${process.env.PUBLIC_URL}/reports/login-failures-report`}
              >
                <LI className="list-hover-primary">
                  <i className="icofont icofont-exclamation-circle text-danger"></i>
                  {t("LoginFailures")}
                </LI>
              </Link>
              <Link to={`${process.env.PUBLIC_URL}/reports/error-log-report`}>
                <LI className="list-hover-primary">
                  <i className="icofont icofont-error text-danger"></i>
                  {t("ErrorLog")}
                </LI>
              </Link>
              <Link to={`${process.env.PUBLIC_URL}/reports/user-trends`}>
                <LI className="list-hover-primary">
                  <i className="icofont icofont-exclamation-circle text-danger"></i>
                  {t("UserTrends")}
                </LI>
              </Link>
              <Link to={`${process.env.PUBLIC_URL}/reports/app-version-reports`}>
                <LI className="list-hover-primary">
                  <i className="icofont icofont-exclamation-circle text-danger"></i>
                  {t("App Version Reports")}
                </LI>
              </Link>
            </UL>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}

export default UserReport;
